import React, { useEffect, useState, useContext } from "react";
import { useOutletContext } from "react-router-dom";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import SocketContext from "../../contexts/SocketContext";
import { useNavigate, useLocation } from "react-router-dom";
import { faPenToSquare, faDeleteLeft, faBan, faD } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFloppyDisk } from "@fortawesome/free-regular-svg-icons";
import DeleteProdSpecModal from "./DeleteProdSpecModal";
import ShortList from "../ShortList/ShortList";
import { generatePdf } from "../Products/GenerateTDS";

import "./ProductDetails.css";

const ProductDetails = () => {
  // General
  const axiosPrivate = useAxiosPrivate();
  const navigate = useNavigate();
  const location = useLocation();

  // Socket
  const { socket } = useContext(SocketContext);

  // Outlet Context Properties
  const [showProdDetails, singleProdNameData] = useOutletContext();

  // Spec Data
  const [specData, setSpecData] = useState();
  const [specTypes, setSpecTypes] = useState();

  // List with Editing Spec Rows
  const [listEditingItems, setListEditingItems] = useState([]);

  // Add new Spec
  // const [addnewspec, setAddnewspec] = useState(false);
  const [addSpecTypeArray, setAddSpecTypeArray] = useState([]);
  const [newspec, setNewSpec] = useState({});

  // Copy Specs
  const [similarproducts, setSimilarproducts] = useState([]);
  const [showhidesimilarprods, setShowhidesimilarprods] = useState(false);
  const [selectedsimilarproduct, setSelectedsimilarproduct] = useState();
  const [selectedsimilarproductID, setSelectedsimilarproductID] = useState();
  const [showhidesimilarprodbuttons, setShowhidesimilarprodbuttons] = useState(false);

  // Delete Spec
  const [showDeleteProdSpec, setShowDeleteProdSpec] = useState(false);
  const [specIDtoDel, setSpecIDtoDel] = useState();

  // Reload Specs
  const [reloadspecs, setReloadspecs] = useState(false);

  // Load Similar Products Function
  const selectSimilarProds = async () => {
    setShowhidesimilarprods(true);
    try {
      const response = await axiosPrivate.get(
        "/api/products/getselectedproducts?prodNameID=" + singleProdNameData.prodNameID
      );
      if (Array.isArray(response.data)) {
        setSimilarproducts(response.data);
      } else {
        setSimilarproducts([]);
      }
    } catch (err) {
      // console.log(err);
      navigate("/login", { state: { from: location }, replace: true });
    }
  };

  // Copy Specs Function
  const copySpecsFrom = async () => {
    try {
      const response = await axiosPrivate.post("/api/products/copyspecsfrom", {
        similarproductID: selectedsimilarproductID,
        productID: singleProdNameData.productID,
      });
      if (response.data.msg === "Copied") {
        setReloadspecs(!reloadspecs);
        socket.emit("copyspecs", singleProdNameData.productID);
      }
    } catch (err) {
      // console.log(err);
      navigate("/login", { state: { from: location }, replace: true });
    }
  };

  // Hide copy spec submenus on new product being loaded
  useEffect(() => {
    setShowhidesimilarprodbuttons(false);
    setSelectedsimilarproduct("");
    setSelectedsimilarproductID(null);
  }, [reloadspecs]);

  // Socket - Receive new specs emited by server socket
  useEffect(() => {
    socket.on("loadnewspecs", (msg) => {
      if (msg === "reload") {
        setReloadspecs(!reloadspecs);
      }
    });
    return () => {
      socket.off("loadnewspecs");
    };
  }, [socket]);

  // Load Prod Specs
  useEffect(() => {
    const getProdSpecs = async () => {
      if (singleProdNameData && singleProdNameData.productID) {
        try {
          const response = await axiosPrivate.post("/api/products/getprodspecsbyprodID", {
            productID: singleProdNameData.productID,
          });
          if (Array.isArray(response.data)) {
            setSpecData(response.data);
          } else {
            setSpecData([]);
          }
        } catch (err) {
          navigate("/login", { state: { from: location }, replace: true });
        }
      }
    };
    getProdSpecs();
    setListEditingItems([]);
    setAddSpecTypeArray([]);
    // setAddnewspec(false);
  }, [singleProdNameData.productID, reloadspecs]);

  // Load Prod Spec Types
  useEffect(() => {
    const getProdSpecTypes = async () => {
      try {
        const response = await axiosPrivate.get("/api/products/getprodspectypes");
        if (Array.isArray(response.data)) {
          setSpecTypes(response.data);
        } else {
          setSpecTypes([]);
        }
      } catch (err) {
        navigate("/login", { state: { from: location }, replace: true });
      }
    };
    getProdSpecTypes();
  }, []);

  //handle Spec Edits
  const handleSpecEdits = (e, id) => {
    const temp = specData.find((item) => item.specID === id);
    const i = specData.findIndex((item) => item.specID === id);
    temp[e.target.name] = e.target.value;
    setSpecData([...specData.slice(0, i), temp, ...specData.slice(i + 1, specData.length)]);
  };

  // Add row for new spec
  const addRowForNewSpec = (e, specTypeID) => {
    setAddSpecTypeArray([...addSpecTypeArray, specTypeID]);
    setNewSpec({
      ...newspec,
      [specTypeID]: { ...newspec[specTypeID], ["specTypeID"]: specTypeID, ["productID"]: singleProdNameData.productID },
    });
    // setAddnewspec(true);
  };

  // Handle New Spec Edits
  const handleNewSpecEdits = (specTypeID, e) => {
    setNewSpec({ ...newspec, [specTypeID]: { ...newspec[specTypeID], [e.target.name]: e.target.value } });
  };

  // Socket functions
  const receivednewprodspec = (newitem) => {
    socket && setSpecData((prev) => [...prev, newitem]);
  };
  const receiveddelspec = (id) => {
    socket &&
      setSpecData((prev) => {
        let ind = prev.findIndex((it) => it.specID === id);
        if (ind !== -1) {
          return [...prev.slice(0, ind), ...prev.slice(ind + 1, prev.length)];
        } else return [...prev];
      });
  };
  const receivedupdateprodspec = (item) => {
    socket &&
      setSpecData((prev) => {
        let ind = prev.findIndex((it) => it.specID === item.specID);
        if (ind !== -1) {
          return [...prev.slice(0, ind), item, ...prev.slice(ind + 1, prev.length)];
        } else return [...prev];
      });
  };

  // Suscribe to socket events
  useEffect(() => {
    socket.on("enewprodspec", (newitem) => {
      receivednewprodspec(newitem);
    });
    socket.on("edeleteprodspec", (id) => {
      receiveddelspec(id);
    });
    socket.on("eupdateprodspec", (item) => {
      receivedupdateprodspec(item);
    });
    return () => {
      socket.off("enewprodspec");
      socket.off("edeleteprodspec");
      socket.off("eupdateprodspec");
    };
  }, [socket]);

  // Save new spec Function
  const saveNewSpec = async (specTypeID, specType) => {
    try {
      const response = await axiosPrivate.post("/api/products/savenewspec", { newspec: newspec[specTypeID] });
      if (response.data.msg === "Saved") {
        let newitem = { ...newspec[specTypeID], ["specID"]: response.data.specID, ["specType"]: specType };
        //emit newspec event to socket
        await socket.emit("newprodspec", newitem);
        //add new spec to specData
        setSpecData((prev) => [...prev, newitem]);
        //remove spectypeID from addSpecTypeArray
        if (addSpecTypeArray.includes(specTypeID)) {
          let ind = addSpecTypeArray.findIndex((el) => el === specTypeID);
          setAddSpecTypeArray((prev) => [...prev.slice(0, ind), ...prev.slice(ind + 1, prev.length)]);
        }
        //remove specTypeID object from newspec object
        const { [specTypeID]: tmp, ...rest } = newspec;
        setNewSpec(rest);
      }
    } catch (err) {
      navigate("/login", { state: { from: location }, replace: true });
    }
  };

  // Delete spec function
  const deleteSpec = async (specID) => {
    try {
      const response = await axiosPrivate.post("/api/products/deletespec", { id: specID });
      if (response.data.msg === "Deleted") {
        await socket.emit("deleteprodspec", specID);
        setSpecData((prev) => {
          let ind = specData.findIndex((it) => it.specID === specID);
          if (ind !== -1) {
            return [...prev.slice(0, ind), ...prev.slice(ind + 1, prev.length)];
          }
        });
        setSpecIDtoDel(null);
      }
    } catch (err) {
      navigate("/login", { state: { from: location }, replace: true });
    }
  };

  // Update spec function
  const updateSpec = async (specID) => {
    let item = specData.find((x) => x.specID === specID);
    try {
      const response = await axiosPrivate.post("/api/products/updatespec", item);
      if (response.data.msg === "Saved") {
        await socket.emit("updateprodspec", item);
        let ind = listEditingItems.indexOf(specID);
        setListEditingItems([
          ...listEditingItems.slice(0, ind),
          ...listEditingItems.slice(ind + 1, listEditingItems.length),
        ]);
      }
    } catch (err) {
      navigate("/login", { state: { from: location }, replace: true });
    }
  };

  return (
    <div className='prodDetails'>
      {showDeleteProdSpec && (
        <DeleteProdSpecModal
          show={showDeleteProdSpec}
          setShow={setShowDeleteProdSpec}
          specID={specIDtoDel}
          deleteSpec={deleteSpec}
        />
      )}
      {showProdDetails && (
        <>
          {/* HEADER */}
          <h1>{singleProdNameData.prodName}</h1>
          <ul className='prodDescription'>
            <li className='prodDescriptor'>
              <p>Producer:</p>
              <p>{singleProdNameData.companyCode}</p>
            </li>

            {/* Copy Specs From */}
            <div className='copyspecsfromsection'>
              <button
                onClick={(e) => {
                  selectSimilarProds();
                }}
              >
                Copy From:
              </button>
              <p>{selectedsimilarproduct ? selectedsimilarproduct : ""}</p>
              <button
                className={showhidesimilarprodbuttons ? "showblock confirmbutton" : "hidden"}
                onClick={(e) => copySpecsFrom()}
              >
                Confirm
              </button>
              <button
                className={showhidesimilarprodbuttons ? "showblock cancelbutton" : "hidden"}
                onClick={(e) => {
                  setShowhidesimilarprodbuttons(false);
                  setSelectedsimilarproduct("");
                  setSelectedsimilarproductID(null);
                }}
              >
                Cancel
              </button>
            </div>
            <ul className={showhidesimilarprods ? "showblock similarprodlist" : "hidden similarprodlist"}>
              {similarproducts &&
                similarproducts.map((prod) => (
                  <li
                    onClick={(e) => {
                      setSelectedsimilarproduct(prod.companyCode);
                      setSelectedsimilarproductID(prod.productID);
                      setShowhidesimilarprods(false);
                      setShowhidesimilarprodbuttons(true);
                    }}
                  >
                    {prod.companyCode}
                  </li>
                ))}
            </ul>
          </ul>

          {/* Product Specs */}
          <div className='prodSpecs'>
            <h2>Typical Specs:</h2>
            {specTypes &&
              specTypes
                .sort((a, b) => a.specTypeID - b.specTypeID) // sort ASC by specTypeID
                .map((stype) => {
                  return [
                    <h3>{stype.specType}</h3>,
                    specData &&
                      specData.map((item) => {
                        if (item.specType === stype.specType) {
                          // Show p if not editing
                          if (!listEditingItems.includes(item.specID)) {
                            return (
                              <div className='specrow'>
                                <p style={{ flex: 4 }}>{item.specName}</p>
                                <p style={{ flex: 2, textAlign: "right", marginLeft: "1rem" }}>{item.specValue}</p>
                                <div style={{ flex: 1, marginLeft: "0.5rem" }}>
                                  <FontAwesomeIcon
                                    className='prodSpecEditIcon'
                                    icon={faPenToSquare}
                                    onClick={(e) => {
                                      if (!listEditingItems.includes(item.specID)) {
                                        setListEditingItems([...listEditingItems, item.specID]);
                                      }
                                    }}
                                  />
                                  <FontAwesomeIcon
                                    className='prodSpecEditIcon'
                                    icon={faDeleteLeft}
                                    onClick={(e) => {
                                      setShowDeleteProdSpec(true);
                                      setSpecIDtoDel(item.specID);
                                    }}
                                  />
                                </div>
                              </div>
                            );

                            // show inputs if editing
                          } else if (listEditingItems.includes(item.specID)) {
                            return (
                              <div className='specrow'>
                                <input
                                  style={{ flex: 4 }}
                                  name='specName'
                                  value={item.specName}
                                  onChange={(e) => {
                                    handleSpecEdits(e, item.specID);
                                  }}
                                />
                                <input
                                  style={{ flex: 2, textAlign: "right", marginLeft: "1rem" }}
                                  name='specValue'
                                  value={item.specValue}
                                  onChange={(e) => {
                                    handleSpecEdits(e, item.specID);
                                  }}
                                />
                                <div style={{ display: "flex", flex: 1 }}>
                                  <FontAwesomeIcon
                                    className='prodSpecEditIcon'
                                    icon={faBan}
                                    onClick={(e) => {
                                      if (listEditingItems.includes(item.specID)) {
                                        let ind = listEditingItems.findIndex((el) => el === item.specID);
                                        setListEditingItems((prev) => [
                                          ...prev.slice(0, ind),
                                          ...prev.slice(ind + 1, prev.length),
                                        ]);
                                      }
                                    }}
                                  />
                                  <FontAwesomeIcon
                                    className='prodSpecEditIcon'
                                    icon={faFloppyDisk}
                                    onClick={(e) => {
                                      updateSpec(item.specID);
                                    }}
                                  />
                                </div>
                              </div>
                            );
                          }
                        }
                      }),

                    // Add a new spec
                    addSpecTypeArray.includes(stype.specTypeID) && (
                      <div className='specrow'>
                        <input
                          name='specName'
                          style={{ flex: 4 }}
                          onChange={(e) => handleNewSpecEdits(stype.specTypeID, e)}
                          value={newspec[stype.specTypeID]?.specName}
                        />
                        <input
                          name='specValue'
                          style={{ flex: 2, textAlign: "right", marginLeft: "1rem" }}
                          onChange={(e) => handleNewSpecEdits(stype.specTypeID, e)}
                          value={newspec[stype.specTypeID]?.specValue}
                        />
                        <div style={{ display: "flex", flex: 1 }}>
                          <FontAwesomeIcon
                            className='prodSpecEditIcon'
                            icon={faBan}
                            onClick={(e) => {
                              if (addSpecTypeArray.includes(stype.specTypeID)) {
                                let ind = addSpecTypeArray.findIndex((el) => el === stype.specTypeID);
                                setAddSpecTypeArray((prev) => [
                                  ...prev.slice(0, ind),
                                  ...prev.slice(ind + 1, prev.length),
                                ]);
                              }
                            }}
                          />
                          <FontAwesomeIcon
                            className='prodSpecEditIcon'
                            icon={faFloppyDisk}
                            onClick={(e) => saveNewSpec(stype.specTypeID, stype.specType)}
                          />
                        </div>
                      </div>
                    ),

                    // Button to show a new row to add a new spec
                    !addSpecTypeArray.includes(stype.specTypeID) && (
                      <p className='addSpecButton' onClick={(e) => addRowForNewSpec(e, stype.specTypeID)}>
                        Add
                      </p>
                    ),
                  ];
                })}
          </div>
          <button type='button' onClick={() => generatePdf(singleProdNameData.prodName, specData ? specData : [])}>
            Generate TDS
          </button>
        </>
      )}
    </div>
  );
};

export default ProductDetails;

// Socket - Emit call to join Product Room by ID.
// useEffect(() => {
//   socket.emit("productRoom", singleProdNameData.productID);
// }, [singleProdNameData.productID]);

{
  /* <h3>Chemical Composition</h3>
            <ShortList
              listType='productchemspecs'
              listID={singleProdNameData.productID}
              URL={"/products/getprodspecs?productID=" + singleProdNameData.productID + "&specType=chemical"}
              updateURL='/products/updatespec'
              insertURL='/products/savenewspec'
              deleteURL='/products/deletespec'
              columns={["specName", "specValue", "specType"]}
              hiddenColumns={["specType", "productID"]}
              hiddenColDefaults={["chemical", singleProdNameData.productID]}
              reloader={reloadspecs}
              itemID='specID'
            />
            <h3>Physical Characteristics</h3>
            <ShortList
              listType='productphysicalspecs'
              listID={singleProdNameData.productID}
              URL={"/products/getprodspecs?productID=" + singleProdNameData.productID + "&specType=physical"}
              updateURL='/products/updatespec'
              insertURL='/products/savenewspec'
              deleteURL='/products/deletespec'
              columns={["specName", "specValue", "specType"]}
              hiddenColumns={["specType", "productID"]}
              hiddenColDefaults={["physical", singleProdNameData.productID]}
              reloader={reloadspecs}
              itemID='specID'
            />
            <h3>Granulometry</h3>
            <ShortList
              listType='productgranulomspecs'
              listID={singleProdNameData.productID}
              URL={"/products/getprodspecs?productID=" + singleProdNameData.productID + "&specType=granulometry"}
              updateURL='/products/updatespec'
              insertURL='/products/savenewspec'
              deleteURL='/products/deletespec'
              columns={["specName", "specValue", "specType"]}
              hiddenColumns={["specType", "productID"]}
              hiddenColDefaults={["granulometry", singleProdNameData.productID]}
              reloader={reloadspecs}
              itemID='specID'
            />
            <h3>Heavy Metals</h3>
            <ShortList
              listType='producthmspecs'
              listID={singleProdNameData.productID}
              URL={"/products/getprodspecs?productID=" + singleProdNameData.productID + "&specType=heavymetals"}
              updateURL='/products/updatespec'
              insertURL='/products/savenewspec'
              deleteURL='/products/deletespec'
              columns={["specName", "specValue", "specType"]}
              hiddenColumns={["specType", "productID"]}
              hiddenColDefaults={["heavymetals", singleProdNameData.productID]}
              reloader={reloadspecs}
              itemID='specID'
            /> */
}
